// English strings for the Adyvance Wallet (BILLING-001, owner 2026-10-25; D-064). Spread into `en` as
// `en.adyWallet`, so keys read `t("adyWallet.…")`. Copy rules: DESIGN_SYSTEM §9.6 (plain, short).
export const adyWalletStrings = {
  title: "Adyvance Wallet",
  lead: "One balance for everything you buy from Adyvance: plans, SMS, root AI, themes, ads and imports.",
  chip: "Wallet balance {amount}",
  // The top-bar wallet button opens this summary (owner, 2026-10-25).
  menu: {
    label: "Wallet summary",
    open: "Open wallet",
    month: "This month",
    next: "Next payment",
    lasts: "~{days} days",
    lastsLong: "1 year+",
    planUntil: "{plan} · {date}",
    sms: "SMS",
    smsLeft: "{count} left",
    ai: "root AI",
    aiUsed: "{used} of {limit} used",
    aiExtra: "{extra} extra",
  },
  balance: {
    label: "Wallet balance",
    available: "Available",
    held: "Held for sends",
    waiting: "{amount} being checked",
    topup: "Top up",
    unit: "1 credit = Rs 1",
    rule: "For this business only. It can't be withdrawn or moved to another business.",
    lasts: "Lasts about {days} days at your pace",
    lastsLong: "Lasts more than a year at your pace",
    noSpend: "No spending in the last 30 days",
    low: "Low balance",
  },
  tabs: {
    overview: "Overview",
    plan: "Plan",
    activity: "Activity",
    topups: "Top-ups",
  },
  insights: {
    title: "Smart insights",
    spentMonth: "Spent this month",
    addedMonth: "Added this month",
    daily: "Average per day",
    suggested: "Suggested top-up",
    suggestedBody: "Covers what's due in the next 30 days and a month at your pace.",
    nothingDue: "You're covered for the next 30 days.",
    add: "Add {amount}",
    months: "Last 6 months",
    in: "Added",
    out: "Spent",
    byCategory: "Where it went this month",
    nothing: "Nothing spent this month yet.",
  },
  tips: {
    low_balance: "Your balance is low ({available}). Top up so your services keep running.",
    renewal_short: "Your {plan} plan renews in {days} days. Add {short} so it renews on time.",
    auto_renew_off:
      "Your {plan} plan ends in {days} days and won't renew by itself. Turn on auto-renew or renew now.",
    bonus_next: "Top up {min} or more and get {percent}% extra credit.",
    pending_topup: "Top-ups being checked by Adyvance: {count} ({amount}).",
    import_due: "Product Import payments due: {count} ({amount}).",
  },
  upcoming: {
    title: "Coming up",
    none: "Nothing due right now.",
    auto: "Auto-renew",
    manual: "Pay yourself",
    covered: "Covered",
    short: "Not enough yet",
    due: "Due {date}",
    pay: "Pay",
  },
  spend: {
    title: "Spend it on",
    plan: "Plan",
    planBody: "{plan} plan",
    planFree: "Free plan · upgrade any time",
    planUntil: "{plan} until {date}",
    sms: "SMS credits",
    smsBody: "{count} SMS left",
    ai: "root AI credits",
    aiBody: "{used} of {limit} this month · {extra} extra",
    aiNoPlan: "{extra} extra credits",
    themes: "Premium themes",
    themesBody: "{owned} of {count} owned",
    themesNone: "Coming soon",
    ads: "Digital Marketing ads",
    adsBody: "{live} live · {review} in review",
    import: "Product Import",
    importBody: "{amount} due",
    importNone: "Nothing due",
    addons: "Add-ons",
    addonsBody: "Extra locations, POS registers",
    open: "Open",
    buy: "Buy",
  },
  categories: {
    plan: "Plan",
    sms: "SMS credits",
    ai: "root AI",
    theme: "Themes",
    ads: "Ads",
    import: "Product Import",
    addon: "Add-ons",
    messages: "Messages",
    topup: "Top-up",
    bonus: "Bonus",
    adjustment: "By Adyvance",
  },
  activity: {
    title: "Recent activity",
    all: "All",
    in: "Added",
    out: "Spent",
    empty: "No wallet activity yet",
    emptyBody: "Top-ups and everything you buy from Adyvance show here.",
    more: "Show older",
    export: "Export CSV",
    viewAll: "View all",
    balanceAfter: "Balance {amount}",
    kinds: {
      topup: "Added",
      mission: "Bonus",
      refund: "Money back",
      debit: "Spent",
      reserve: "Held",
      release: "Released",
    },
  },
  topups: {
    title: "Your top-ups",
    empty: "No top-ups yet",
    emptyBody:
      "Add money by QR or bank transfer. Adyvance checks the receipt and adds it to your balance.",
    states: {
      submitted: "Being checked",
      confirmed: "Added",
      rejected: "Not added",
      cancelled: "Cancelled",
    },
    credited: "{amount} added",
    bonus: "+{amount} bonus",
    cancel: "Cancel",
    cancelled: "Top-up cancelled",
    why: "Adyvance: {note}",
  },
  topup: {
    title: "Top up your wallet",
    lead: "Pay by Fonepay and it's added at once, or pay by QR or bank and send the receipt.",
    leadOnline: "Pay by Fonepay with any bank, wallet or card: it's added at once.",
    leadReceipt: "Pay by QR or bank, then send the receipt: it's added once Adyvance checks it.",
    amount: "Amount",
    custom: "Other amount",
    min: "From {min} to {max}",
    pay: "How you pay",
    methods: {
      qr: "QR",
      bank: "Bank",
      fonepay: "Fonepay QR",
      fonepay_web: "Fonepay",
    },
    soon: "Soon",
    scan: "Scan with any banking or wallet app and pay {amount}.",
    noQr: "Adyvance's QR code isn't added yet. Pay by bank transfer, or ask Adyvance support.",
    noBank: "Adyvance's bank details aren't added yet. Ask Adyvance support.",
    bank: { bank: "Bank", name: "Account name", number: "Account number" },
    copy: "Copy",
    copied: "Copied",
    proof: "Receipt",
    reference: "Transaction ID",
    referenceHelp: "The ID or reference shown on your payment receipt",
    upload: "Upload the receipt",
    uploading: "Uploading…",
    change: "Change",
    note: "Note for Adyvance (optional)",
    summary: "Summary",
    youPay: "You pay",
    bonus: "Bonus",
    youGet: "Added to wallet",
    after: "Balance after",
    need: "Add the receipt or the transaction ID.",
    submit: "Send for checking",
    sent: "Top-up sent. Adyvance will check it soon.",
    close: "Close",
    rules:
      "Wallet money can only be spent on Adyvance services. It can't be withdrawn or refunded.",
    photoError: "The receipt could not be uploaded. Try a JPG, PNG, WebP or PDF up to 5 MB.",
    forItem: "You need {amount} more for this.",
    // D-085: paying Adyvance by Fonepay Dynamic QR.
    onlineLead: "Scan a QR with any bank or wallet app; the money is added to your wallet at once.",
    payWith: "Pay {amount} by {name}",
  },
  // D-085: the Fonepay Dynamic QR popup and its result.
  online: {
    title: "Pay by Fonepay QR",
    qrTitle: "Scan to pay {amount}",
    qrHelp:
      "Open any bank or wallet app that pays by Fonepay QR (eSewa, Khalti, mobile banking), scan and pay.",
    qrLeft: "QR works for {time}",
    qrExpired: "This QR expired. Get a new one to pay.",
    qrNew: "New QR",
    qrLabel: "Fonepay payment QR code",
    waiting: "Waiting for your payment…",
    payQr: "Fonepay QR",
    // D-122: Fonepay hosted checkout (Fonepay's own payment page).
    payWeb: "Fonepay",
    webTitle: "Pay on Fonepay",
    webGoing: "Taking you to Fonepay…",
    webHelp:
      "Pay on Fonepay's page with any bank, wallet or card. You come back here when it's done.",
    webChecking: "Checking your payment with Fonepay…",
    webPending:
      "Fonepay hasn't confirmed this payment. If you paid, it's added within a few minutes; otherwise try again.",
    webUnknown:
      "We couldn't find that payment. If money left your account, contact Adyvance support.",
    credited: "Payment received. {amount} is in your wallet.",
    bought: "Payment received. Your purchase is done.",
    kept: "Payment received and {amount} added to your wallet, but the purchase didn't go through. Buy it from your wallet.",
    failed: "The payment didn't go through.",
    cancelled: "The payment was cancelled.",
    expired: "The payment wasn't finished in time.",
    test: "Test payment",
    close: "Close",
    direct: "Or pay {amount} directly",
    directHelp: "Paid online and bought at once; your wallet balance stays the same.",
    kinds: {
      topup: "Top-up",
      plan: "Plan",
      addon: "Add-on",
      ai_pack: "root AI credits",
      theme: "Theme",
      sms_pack: "SMS credits",
      import_payment: "Import order",
      ads_campaign: "Digital Marketing ad",
    },
    states: {
      pending: "Waiting",
      paid: "Paid",
      failed: "Failed",
      expired: "Expired",
      cancelled: "Cancelled",
    },
    outcomes: {
      credited: "Added to wallet",
      bought: "Bought",
      kept_in_wallet: "Kept in wallet",
    },
  },
  pay: {
    title: "Pay from Adyvance Wallet",
    price: "Price",
    available: "Wallet balance",
    after: "After paying",
    short: "You need {amount} more.",
    topupShort: "Top up {amount}",
    confirm: "Pay {amount}",
    paid: "Paid from your wallet",
  },
  plan: {
    title: "Your plan",
    current: "Current plan",
    free: "Free",
    until: "Paid until {date}",
    grace: "In grace until {date}: renew to keep your plan",
    trialUntil: "Trial until {date}",
    autoRenew: "Auto-renew from wallet",
    autoRenewBody:
      "Renews on the end date if your wallet covers {amount}. We remind you before it ends; a plan not renewed moves to the Free plan.",
    autoRenewOn: "Auto-renew turned on",
    autoRenewOff: "Auto-renew turned off",
    renewNow: "Renew now",
    choose: "Choose a plan",
    periods: { monthly: "Monthly", quarterly: "3 months", yearly: "Yearly" },
    perMonth: "{amount}/month",
    month: "/ month",
    period: "Period",
    save: "Save {pct}%",
    currentBadge: "Current",
    pick: "Choose",
    switchTo: "Switch to {plan}",
    renew: "Renew {plan}",
    credit: "You get {amount} back for the unused days of your current plan.",
    noPlans: "No paid plans yet",
    noPlansBody: "Adyvance hasn't put paid plans on sale yet. Your business stays on Free.",
    includes: "Includes",
    bought: "Plan paid. It's active now.",
    renewed: "Plan renewed until {date}.",
    invoices: "Invoices",
    limits: {
      products: "{n} products",
      staff: "{n} staff",
      stores: "{n} stores",
      orders_month: "{n} orders a month",
      sms_month: "{n} SMS a month",
      ai_credits_month: "{n} root AI credits a month",
      locations: "{n} locations",
      pos_registers: "{n} POS registers",
      automations: "{n} automations",
      unlimited: "Unlimited {what}",
      products_one: "1 product",
      staff_one: "1 staff member",
      stores_one: "1 store",
      locations_one: "1 location",
      pos_registers_one: "1 POS register",
      automations_one: "1 automation",
    },
  },
  ai: {
    title: "Buy root AI credits",
    lead: "Extra credits for root. They're used after your plan's monthly credits and never expire.",
    month: "This month: {used} of {limit} plan credits used",
    monthNone: "Your plan has no monthly root credits",
    extra: "Extra credits: {count}",
    packs: "Packs",
    noPacks: "No packs on sale yet. Adyvance will add them soon.",
    credits: "{count} credits",
    perCredit: "{price} per credit",
    best: "Best value",
    bought: "root AI credits added",
  },
  themes: {
    title: "Premium themes",
    lead: "Buy a theme once and switch your store to it from Online store → Themes.",
    none: "No premium themes yet",
    noneBody: "All themes are free for now.",
    once: "One-time",
    yearly: "Per year",
    owned: "Owned",
    ownedUntil: "Yours until {date}",
    buy: "Buy",
    extend: "Add a year",
    bought: "Theme bought. You can switch to it now.",
    locked: "Premium · {price}",
  },
  addons: {
    title: "Add-ons",
    lead: "Raise a limit of your plan for one month.",
    none: "No add-ons on sale yet",
    month: "{price} a month",
    quantity: "How many",
    bought: "Add-on active until {date}",
    offers: {
      extra_location: "Extra location",
      extra_pos_register: "Extra POS register",
    },
  },
  errorCodes: {
    insufficient_balance:
      "Your Adyvance Wallet doesn't have enough money for this. Top up and try again.",
    theme_locked: "This is a premium theme. Buy it from your Adyvance Wallet first.",
    duplicate_reference: "This transaction ID was already sent.",
    topups_waiting: "You already have top-ups being checked. Wait for them first.",
    topup_amount: "That amount is outside what you can add at once.",
    topup_decided: "Adyvance has already checked this top-up.",
    proof_required: "Add the receipt or the transaction ID.",
    method_off: "This way of paying isn't available. Choose another.",
    no_paid_plan: "Auto-renew needs a paid plan. Choose a plan first.",
    not_on_sale: "This isn't on sale yet.",
    already_owned: "You already own this.",
    gateway_unavailable: "The payment service didn't answer. Try again or pay another way.",
    payments_open: "You have several payments still open. Finish or wait for them first.",
    amount_too_small: "This amount is too small for this payment method.",
  },
  errors: {
    duplicate: "This transaction ID was already sent.",
    waiting: "You already have top-ups being checked. Wait for them first.",
    amount: "That amount is outside what you can add at once.",
  },
  console: {
    lead: "Shops' wallet money: top-ups to check, balances, pack and theme prices, and settings.",
    held: "Held for shops",
    waiting: "To check",
    added: "Added this month",
    spent: "Spent this month",
    tabs: {
      topups: "Top-ups",
      wallets: "Wallets",
      plans: "Plans",
      prices: "Prices",
      settings: "Settings",
    },
    topups: {
      empty: "No top-ups yet",
      none: "Nothing to check",
      all: "All",
      waiting: "To check",
      confirm: "Add to wallet",
      reject: "Reject",
      amount: "Amount to add",
      amountHelp: "Change it if the receipt shows a different amount.",
      reason: "Note for the shop (needed to reject)",
      duplicate: "Same transaction ID as: {list}",
      receipt: "Receipt",
      noReceipt: "No receipt, transaction ID only",
      confirmed: "Added to the wallet",
      rejected: "Top-up rejected",
      bonus: "Bonus {amount}",
      online: "Online",
      onlineEmpty: "No online payments yet",
    },
    // D-084: Adyvance's own eSewa, Khalti and Fonepay accounts.
    gateways: {
      title: "Fonepay QR",
      // D-122: one card per gateway.
      titles: { fonepay: "Fonepay Dynamic QR", fonepay_web: "Fonepay checkout" },
      lead: "Let shops pay Adyvance by Fonepay Dynamic QR. Keys are encrypted when saved; only their last 4 characters are shown again.",
      on: "On",
      off: "Off",
      keysMissing: "Keys missing",
      enable: "Shops can pay with {name}",
      keysTitle: "Merchant details",
      keysSaved: "{n} of {total} saved",
      enableHelp: "Save every key first.",
      mode: "Mode",
      modes: { test: "Test", live: "Live" },
      modeHelp: "Live takes real payments, also on the testing site.",
      fields: {
        merchant_code: "Merchant code",
        merchant_id: "Merchant ID",
        secret_key: "Secret key",
        username: "Username",
        password: "Password",
      },
      savedKey: "Saved · ends in {last4}",
      savedShort: "Saved",
      keep: "Leave empty to keep the saved key",
      help: {
        fonepay:
          "The four details Fonepay gives for Dynamic QR. Shops scan one QR with any bank or wallet app.",
        fonepay_web:
          "Fonepay's own payment page: shops pay with any bank, wallet or card on Fonepay and come back. Needs only the merchant ID and secret key.",
      },
      save: "Save",
      saved: "{name} saved",
      remove: "Remove keys",
      removeConfirm: "Remove {name}'s keys? Shops can't pay with it until you add them again.",
      removed: "{name} keys removed",
    },
    wallets: {
      search: "Search businesses",
      balance: "Balance",
      spent: "Spent 30 days",
      last: "Last activity",
      adjust: "Adjust",
      adjustTitle: "Adjust {org}'s wallet",
      give: "Give",
      take: "Take",
      reason: "Reason",
      done: "Wallet adjusted",
      history: "History",
      empty: "No wallets yet",
    },
    plans: {
      add: "New plan",
      key: "Key (letters, for code)",
      name: "Name",
      summary: "Short description",
      badge: "Badge (optional)",
      sort: "Order",
      onSale: "On sale",
      trial: "Free trial days",
      prices: "Prices",
      limits: "Limits and features",
      unlimited: "-1 = unlimited",
      subscribers: "On this plan: {count}",
      save: "Save plan",
      saved: "Plan saved",
      freeNote: "Free stays on for everyone and has no price.",
    },
    prices: {
      ai: "root AI credit packs",
      themes: "Premium theme prices",
      addons: "Add-on prices (per month)",
      credits: "Credits",
      price: "Price",
      active: "On sale",
      addPack: "Add a pack",
      free: "Free",
      period: "Charged",
      owners: "Owners: {count}",
      save: "Save",
      saved: "Prices saved",
    },
    settings: {
      // Compact settings (owner, 2026-10-28).
      unsaved: "You have unsaved changes",
      upToDate: "Wallet settings are up to date",
      discard: "Discard",
      amounts: "Top-up amounts",
      amountsHelp: "The quick amount buttons shops see, and the limits for one top-up.",
      addAmount: "Add an amount button",
      amountPh: "Amount",
      add: "Add",
      removeAmount: "Remove {amount}",
      minShort: "Smallest",
      maxShort: "Largest",
      lowShort: "Low-balance alert",
      noBonus: "No bonus yet. Add a tier to reward bigger top-ups.",
      bonusExample: "+{bonus} on {amount}",
      bonusRule: "The highest tier a top-up reaches applies. Fonepay QR top-ups get it too.",
      removeTier: "Remove this tier",
      presets: "Amount buttons (Rs)",
      min: "Smallest top-up (Rs)",
      max: "Largest top-up (Rs)",
      bonus: "Top-up bonus",
      bonusHelp: "Top up at least this much and get this much extra.",
      addTier: "Add a tier",
      from: "From (Rs)",
      percent: "Extra %",
      low: "Low-balance alert below (Rs)",
      saved: "Wallet settings saved",
      save: "Save settings",
    },
  },
} as const;
